import {
  Form,
  Input,
  Select,
  AutoComplete,
  Button,
  Card,
  Spin,
  InputNumber,
  Tag,
  Icon,
  Tooltip
} from "antd";
import React, { Component } from "react";
import { showSuccessToast, showErrorToast } from "../general/ToastHelper";
import withSharedStateConsumer from "../../contexts/shared-state/withSharedStateConsumer";
import { AccountService } from "../../services/account/AccountService";
import { withRouter } from "react-router-dom";
import { handleError } from "../../utils/ErrorHandlers";
import Page from "../general/Page";
import { PackageAndPrivilegeService } from "../../services/packageAndPrivilege/PackageAndPrivilegeService";
import "./Accounts.css";
import "./AccountForm.css";
import "./UpdateAccountForm.css";
import { Translation } from "react-i18next";
import i18next from "i18next";
const prefNum = "010";
class UpdateAccountForm extends Component {
  packageAndPrivilegeService = new PackageAndPrivilegeService();
  accountService = new AccountService();

  constructor(props) {
    super(props);
    this.props.context.setCurrentComponent("editAccounts");
    this.state = {
      account: {},
      cfg: {},
      isFetching: false,
      formLayout: "inline",
      loading: false,
      inputVisible: false,
      inputValue: "",
      tags: [],
      packages: [],
      accountNumbers: [],
      oldPackage: "",
    };
  }
  async getAllPackages() {
    try {
      let data = await this.packageAndPrivilegeService.getPackagesList(
        this.props.context.session_id
      );
      return data;
    } catch (e) {
      throw e;
    }
  }
  async getAllAccountMSISDN() {
    try {
      let data = await this.accountService.getAllAccountMSISDN(
        this.props.context.session_id
      );
      return data;
    } catch (e) {
      throw e;
    }
  }

  async componentDidMount() {
    try {
      this.setState({ isFetching: true });
      let [packages, account, accountNumbers] = await Promise.all([
        this.getAllPackages(),
        this.getAccountData(),
        // this.getAllAccountMSISDN(),
      ]);
      this.setState({
        packages: packages.ivrList,
        // accountNumbers: accountNumbers.ivrList,
        isFetching: false,
        cfgPackages: packages.cfgList,
      });
    } catch (e) {
      this.setState({ isFetching: false });
      handleError(e);
    }
  }
  async getAccountData() {
    let { id } = this.props.match.params;
    let { isFetching } = this.state;
    this.acc = new AccountService();
    try {
      this.setState({ isFetching: true });
      let account = await this.acc.getAccountsByIdService(
        this.props.context.session_id,
        id
      );
      var cfg = {};
      cfg.pkg_name = "";
      cfg.agents_max_num = "";
      cfg.account_numbers = [];
      var oldPackage = "";

      if (account.ivrCustomEntityObject.cfg.length) {
        account.ivrCustomEntityObject.cfg.forEach((element) => {
          if (Object.getOwnPropertyNames(element).indexOf("PKG_NAME") > -1) {
            cfg.pkg_name = element["PKG_NAME"];
            oldPackage = element["PKG_NAME"];
          }
          if (
            Object.getOwnPropertyNames(element).indexOf("AGENTS_MAX_NUMBER") >
            -1
          ) {
            cfg.agents_max_num = element["AGENTS_MAX_NUMBER"];
          }
          if (
            Object.getOwnPropertyNames(element).indexOf(
              "MAX_CONCURRENT_CALLS"
            ) > -1
          ) {
            cfg.max_concurrent_calls = element["MAX_CONCURRENT_CALLS"];
          }
          if (
            Object.getOwnPropertyNames(element).indexOf("ACCOUNT_NUMBERS") > -1
          ) {
            if (element["ACCOUNT_NUMBERS"] === "") {
              cfg.account_numbers = [];
            } else {
              cfg.account_numbers = element["ACCOUNT_NUMBERS"].split(",");
            }
          }
        });
      }
      this.setState({
        account: account.ivrCustomEntityObject,
        isFetching: false,
        cfg: cfg,
        tags: cfg.account_numbers,
        oldPackage: oldPackage,
      });
    } catch (error) {
      this.setState({
        isFetching: false,
      });
      handleError(error);
    }
  }

  handleDropdownPackagesChange = (e) => {
    this.setState({ inputValue: e });
  };

  handleChange(e) {
    const { id, value } = e.target;
    let { account } = this.state;
    account[id] = value;
    this.setState({ account });
  }

  handleDropdownChange(value) {
    let { account } = this.state;
    account.accountStatus = value;
    this.setState({ account });
  }

  handleConfirm = (e) => {
    e.preventDefault();

    this.props.form.validateFields(async (err, values) => {
      values.accountId = this.state.account.accountId;
      values.accountStatus = this.state.account.accountStatus;

      let cfg = [
        // {
        //   key: "PKG_NAME",
        //   value: this.state.cfg.pkg_name,
        //   configCategory: "GENERAL",
        //   accountID: this.state.account.accountId,
        // },
        // {
        //   key: "AGENTS_MAX_NUMBER",
        //   value: this.state.cfg.agents_max_num,
        //   configCategory: "GENERAL",
        //   accountID: this.state.account.accountId,
        // },
        // {
        //   key: "MAX_CONCURRENT_CALLS",
        //   value: this.state.cfg.max_concurrent_calls,
        //   configCategory: "GENERAL",
        //   accountID: this.state.account.accountId,
        // },
        {
          key: "ACCOUNT_NUMBERS",
          value: this.state.cfg.account_numbers
            ? this.state.cfg.account_numbers.join()
            : [],
          configCategory: "GENERAL",
          accountID: this.state.account.accountId,
        },
      ];
      values.cfg = cfg;

      try {
        if (!err) {
          this.setState({ loading: true });
          this.acc = new AccountService();

          let data = await this.acc.editAccount(
            this.props.context.session_id,
            values
          );
          if (this.state.oldPackage !== this.state.cfg.pkg_name) {
            let result = await this.acc.upgradeOrDowngradeAccount(
              this.props.context.session_id,
              {
                billingId: this.state.account.billingId,
                pkgCode: this.state.cfg.pkg_name,
                accountId: this.state.account.accountId,
              }
            );
            this.setState({ oldPackage: this.state.cfg.pkg_name });
          }

          this.setState({ loading: false });
          showSuccessToast(i18next.t("Account edited successfully"));
        }
      } catch (e) {
        this.setState({ loading: false });

        handleError(e);
      }
    });
  };

  handleClose = (removedTag) => {
    const tags = this.state.tags.filter((tag) => tag !== removedTag);

    this.setState({ tags, inputVisible: true });
  };

  showInput = () => {
    this.setState({ inputVisible: true }, () => this.input.focus());
  };

  handleInputChange = (e) => {
    this.setState({ inputValue: e.target.value });
  };

  handleInputConfirm = () => {
    const { inputValue } = this.state;
    let { tags } = this.state;
    if (inputValue && tags.indexOf(inputValue) === -1) {
      tags = [...tags, prefNum + inputValue];
    }
    this.setState({
      tags,
      inputVisible: false,
      inputValue: "",
    });
  };
  handleChangeMaxAgents(e) {
    let value = e;
    let { cfg } = this.state;
    cfg.agents_max_num = value;
    this.handleChangeMaxConcurrentCalls(value);
    this.setState({ cfg });
  }
  handleChangeMaxConcurrentCalls(e) {
    let value = e;
    let { cfg } = this.state;

    cfg.max_concurrent_calls = value;
    this.setState({ cfg });
  }
  handlePackageName(e) {
    let value = e;
    let { cfg } = this.state;
    // account[id] = value;
    cfg.pkg_name = value;
    this.setState({ cfg });

    this.state.cfgPackages.forEach((element) => {
      if (element.pkgCode == e && element.key == "AGENTS_MAX_NUMBER") {
        this.handleChangeMaxAgents(element.value);
        this.props.form.setFields({
          AGENTS_MAX_NUMBER: {
            value: element.value,
          },
        });
      }
      if (element.pkgCode == e && element.key == "MAX_CONCURRENT_CALLS") {
        this.handleChangeMaxConcurrentCalls(element.value);
        this.props.form.setFields({
          MAX_CONCURRENT_CALLS: {
            value: element.value,
          },
        });
      }
    });
  }

  handleChangeNumOfAccountNums(e) {
    let value = e;
    this.setState({ tags: [] });
  }
  saveInputRef = (input) => (this.input = input);
  render() {
    const {
      account,
      tags,
      inputVisible,
      inputValue,
      packages,
      accountNumbers,
    } = this.state;
    const { status } = this.props;

    const { getFieldDecorator } = this.props.form;
    const formItemLayout = {
      labelCol: { span: 6 },
      wrapperCol: { span: 14 },
    };
    const { Option } = Select;
    let { isFetching } = this.state;
    const packageOptions = packages.map((opt) => (
      <Option key={opt.pkgCode} value={opt.pkgCode}>
        {opt.pkgName}
      </Option>
    ));
    const accountNumbersOptions = accountNumbers.map((opt) => (
      <Option key={opt.msisdn} value={opt.msisdn}>
        {opt.msisdn}
      </Option>
    ));

    return (
      <Translation>
        {(t) => (
          <Page title={t("Edit Account")} hasBackArrow={true}>
            {isFetching ? (
              <Spin></Spin>
            ) : (
              <div>
                <Card
                  style={{
                    marginTop: "10px",
                    boxShadow: "0 2px 8px rgba(0, 0, 0, 0.15)",
                  }}
                  bordered={false}
                >
                  <Form className="form-style" {...formItemLayout}>
                    <Form.Item label={t("Account Name")} {...formItemLayout}>
                      {getFieldDecorator("accountName", {
                        initialValue: this.state.account.accountName,

                        rules: [
                          {
                            required: true,
                            message: t("Please enter Account Name"),
                          },
                        ],
                      })(<Input onChange={(e) => this.handleChange(e)} />)}
                    </Form.Item>

                    {false && (
                      <Form.Item
                        label={t("Account Contact Name")}
                        {...formItemLayout}
                      >
                        {getFieldDecorator(
                          "accountContactName",

                          {
                            initialValue: this.state.account.accountContactName,

                            rules: [
                              {
                                required: true,
                                message: t("Please enter Account Contact Name"),
                              },
                            ],
                          }
                        )(<Input onChange={(e) => this.handleChange(e)} />)}
                      </Form.Item>
                    )}
                    <Form.Item
                      label={t("Account Contact Number")}
                      {...formItemLayout}
                    >
                      {getFieldDecorator("accountContactNumber", {
                        initialValue: this.state.account.accountContactNumber,

                        rules: [
                          {
                            required: true,
                            min: 12,
                            max: 12,
                            pattern: "^([2][0][1])(?:[0]|[1]|[2]|[5])[0-9]*$",

                            message: t(
                              "Please enter valid Account Contact Number"
                            ),
                          },
                        ],
                      })(
                        <Input
                          onChange={(e) => this.handleChange(e)}
                          maxLength={12}
                        />
                      )}
                    </Form.Item>
                    <Form.Item
                      label={t("Account Contact Email")}
                      {...formItemLayout}
                    >
                      {getFieldDecorator("accountContactEmail", {
                        initialValue: this.state.account.accountContactEmail,
                        rules: [
                          {
                            type: "email",
                            message: t("The input is not valid E-mail!"),
                          },
                          {
                            required: true,
                            message: t("Please enter Account Contact Email"),
                          },
                        ],
                      })(<Input onChange={(e) => this.handleChange(e)} />)}
                    </Form.Item>
                    <Form.Item label={t("Account Status")} {...formItemLayout}>
                      {getFieldDecorator("accountStatus", {
                        initialValue: this.state.account.accountStatus,
                        rules: [
                          {
                            required: true,
                            message: t("Please enter Account  Status"),
                          },
                        ],
                      })(
                        <Select
                          onChange={(value) => this.handleDropdownChange(value)}
                        >
                          <Option value="ACT">{t("Active")}</Option>
                          <Option value="SUS">{t("Suspended")}</Option>
                          {/* <Option value="INT">Initial</Option> */}
                        </Select>
                      )}
                    </Form.Item>
                    <Form.Item label={t("Package Code")} {...formItemLayout}>
                      {getFieldDecorator(
                        "PKG_NAME",
                        { initialValue: this.state.cfg.pkg_name },
                        {
                          rules: [
                            {
                              required: true,
                              message: t("Please enter Account Contact Email"),
                            },
                          ],
                        }
                      )(
                        <Select
                          style={{ width: 120 }}
                          onChange={(e) => this.handlePackageName(e)}
                        >
                          {packageOptions}
                        </Select>
                      )}
                    </Form.Item>
                    <Form.Item
                      label={t("Max Agents Number")}
                      {...formItemLayout}
                    >
                      {getFieldDecorator(
                        "AGENTS_MAX_NUMBER",
                        { initialValue: this.state.cfg.agents_max_num },
                        {
                          rules: [
                            {
                              required: true,
                              message: t("Please enter Max Agents Number"),
                            },
                          ],
                        }
                      )(
                        <InputNumber
                          onChange={(e) => this.handleChangeMaxAgents(e)}
                          disabled={true}
                        />
                      )}
                    </Form.Item>

                    <Form.Item
                      label={t("Max Concurrent Calls")}
                      {...formItemLayout}
                    >
                      {getFieldDecorator(
                        "MAX_CONCURRENT_CALLS",
                        { initialValue: this.state.cfg.max_concurrent_calls },
                        {
                          rules: [
                            {
                              required: true,
                              message: t("Please enter Max Conncurent Calls"),
                            },
                          ],
                        }
                      )(
                        <InputNumber
                          disabled={true}
                          onChange={(e) =>
                            this.handleChangeMaxConcurrentCalls(e)
                          }
                        />
                      )}
                    </Form.Item>
                    {/* <Form.Item label="Account Numbers" {...formItemLayout}>
                  {getFieldDecorator("ACCOUNT_NUMBERS",
                    { initialValue: this.state.cfg.account_numbers },
                   {
                    rules: [
                      {
                        required: true,
                        message: "Please select account numbers"
                      }
                    ]
                  },
                  tags.length !==  0 ?  {
                    initialValue: tags
                  } : {}
                  )(
                     <Select
                     mode="multiple"
                   >
                     {accountNumbersOptions}
                   </Select>
                    )}
                </Form.Item> */}
                    <Form.Item
                      wrapperCol={{
                        xs: { span: 24, offset: 0 },
                        sm: { span: 16, offset: 8 },
                      }}
                    >
                      <Button
                        className="button-submit"
                        type="primary"
                        onClick={this.handleConfirm}
                        size={"small"}
                        loading={this.state.loading}
                      >
                        {t("Submit")}
                      </Button>
                    </Form.Item>
                  </Form>
                </Card>
              </div>
            )}
          </Page>
        )}
      </Translation>
    );
  }
}
export default Form.create()(
  withSharedStateConsumer(withRouter(UpdateAccountForm))
);
